import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroStatusCajaRuta;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    /**Errores de validacion */
    errors?: validation.Result<Entity>;
}


export class FiltroEditor extends React.PureComponent<Props> {
    getField = formfields(() => this.props, () => this.props.errors || {});
    
    render() {
        const {getField, props }=this;
        const Caja = getField(selectores.CajaRuta);
        const DateTime = getField(kea.DateTime);
        return (
            <div>
               {kea.autogrid(3, [
                   <Caja field="IdCaja" label="Caja" />,
                   <DateTime field="FechaInicio"  label="Fecha de inicio"/>,
                   <DateTime field="FechaFinal"  label="Fecha final"/>,
               ])}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/list/filtro.tsx